export interface SiteNavLink {
  label: string;
  href: string;
}

export interface SiteFooterSection {
  title: string;
  links: readonly SiteNavLink[];
}

export const SITE_NAV_PRODUCT: readonly SiteNavLink[] = [
  { label: 'Features', href: '/features' },
  { label: 'Integrations', href: '/integrations' },
  { label: 'MCP', href: '/mcp' },
];

export const SITE_NAV_PAGES: readonly SiteNavLink[] = [
  { label: 'Power', href: '/power' },
  { label: 'Saga', href: '/saga' },
  { label: 'Pricing', href: '/pricing' },
];

export const SITE_NAV_RESOURCES: readonly SiteNavLink[] = [
  { label: 'Articles', href: '/articles' },
  { label: 'Changelog', href: '/changelog' },
  { label: 'Docs', href: '/docs' },
];

/** Flat list for mobile nav and other single-column menus. */
export const SITE_NAV_MOBILE_LINKS: readonly SiteNavLink[] = [
  ...SITE_NAV_PRODUCT,
  ...SITE_NAV_PAGES,
  ...SITE_NAV_RESOURCES,
];

/** Footer columns — every href must match a marketing site route (Figma node 265-306). */
export const SITE_FOOTER_SECTIONS: readonly SiteFooterSection[] = [
  {
    title: 'Product',
    links: [
      { label: 'Features', href: '/features' },
      { label: 'Integrations', href: '/integrations' },
      { label: 'MCP', href: '/mcp' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Articles', href: '/articles' },
      { label: 'Changelog', href: '/changelog' },
      { label: 'Docs', href: '/docs' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Saga', href: '/saga' },
      { label: 'Arvid Power', href: '/power' },
      { label: 'Pricing', href: '/pricing' },
    ],
  },
];
